import { ethers } from 'ethers'

export const weiToEth = (wei: string | number): string | undefined => {
  return isNaN(parseInt(wei.toString())) ? undefined : ethers.utils.formatEther(wei)
}
